<template>
    <div class="bax-section bax-select-patient-wrap">
        <div class="container bax-wide">
            <div class="bax-bg bax-bg-foot-link bax-create-patient">
                <div>
                    <p>Inital import of your file has completed. There are {{ rows_num }} row<span v-if="rows_num !== 1">s</span> in the file. {{ rows_invalid }} of
                        <span v-if="rows_num !== 1">these</span><span v-else> this</span> row<span v-if="rows_num !== 1">s are</span><span v-else> is</span> invalid. Invalid rows will not be imported.</p>
                    <p>Please review your data below and uncheck any valid rows that are not to be imported. If data needs to be corrected then fix it in the csv file and re-upload.</p>
                    <div class="csv-upload-review">
                        <table v-if="rows">
                            <thead>
                            <tr>
                                <th></th>
                                <th class="fieldname-header">Your Field Name <span class="rarr">&rarr;</span></th>
                                <template v-for="(value, field_name) in rows[Object.keys(rows)[0]]">
                                    <th v-bind:key="field_name" v-if="field_name !== 'valid'">
                                        {{ field_name }}
                                    </th>
                                </template>
                            </tr>
                            <tr>
                                <th>Import?</th>
                                <th class="fieldname-header selector-header">Baxter field name <span class="rarr">&rarr;</span></th>
                                <template v-for="(header, field_name) in chosen_headers">
                                    <th v-bind:key="field_name" v-if="field_name !== 'valid'">
                                        <select :name="field_name" v-model="header.value">
                                            <option value="__skip__">-- SKIP COLUMN --</option>
                                            <option v-for="option in baxter_headers" :value="option" v-bind:key="option" :selected="field_name == option">
                                                {{ option }}
                                            </option>
                                        </select>
                                    </th>
                                </template>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for="(row, row_key, row_index) in rows">
                                <tr v-bind:key="row_index" @click="selectRow(row_key, row.valid === 'VALID')">
                                    <td v-if="row.valid === 'VALID'" class="checkbox"><input type="checkbox" checked="checked"  :id="row_key" v-model="selected_rows" :value="row_key"/></td>
                                    <td v-if="row.valid !== 'VALID'" class="checkbox"><input type="checkbox" disabled="disabled"/></td>
                                    <td v-if="row.valid === 'VALID'">{{ row.valid }}</td>
                                    <td v-if="row.valid !== 'VALID'"><p v-for="(validityreason, key, index) in row.valid" v-bind:key="index" class="validity-reason">{{ validityreason }}</p></td>
                                    <template v-for="(field, field_name, field_index) in row">
                                        <td v-bind:key="field_index" v-if="field_name !== 'valid'">
                                            {{ field }}
                                        </td>
                                    </template>
                                </tr>
                            </template>
                            </tbody>
                        </table>
                    </div>
                    <div class="action-buttons">
                        <div v-if="headers_changed">
                            <p>You have changed your headers. You can save over a previous header configuration, or choose to create a new one:</p>
                            <p>
                                <select v-model="cust_header_selected">
                                    <option value="1">[NEW]</option>
                                    <option v-for="(headers_name) in Object.keys(cust_headers)" :value="headers_name" v-bind:key="headers_name">{{headers_name}}</option>
                                </select>
                                <input name="header_name" value="" v-model="headers_name"  class="bax-input-control" v-if="cust_header_selected == 1"/>
                            </p>
                            <p><input type="button" value="Save Headers" class="cancel-btn bax-btn bax-btn-bordered bax-btn-bordered-blue ml-auto mt-3 mt-md-0"  @click="reprocessHeaders();" ></p>
                        </div>
                        <input type="button" value="Cancel Upload" class="cancel-btn bax-btn bax-btn-bordered bax-btn-bordered-blue ml-auto mt-3 mt-md-0"  @click="$emit('cancel_upload');" >

                        <input type="button" :value="'Process ' + selected_rows.length + ' valid row' + (selected_rows.length === 1?'':'s')" class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"  @click="selectedRowsProcess" :disabled="disableSubmit()">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import CsvService from '@/core/api/csv/csv.service3';
    import csvMixin from './csvMixin';

    export default {
        name: 'Stage3',
        mixins: [csvMixin],
        props: ['uploadCode'],
        data() {
            return {
                rows: null,
                filename: null,
                headers_file: null,
                rows_num: null,
                rows_valid: null,
                rows_invalid: null,
                selected_rows: [],
                cust_headers: [],
                cust_header_chosen: null,
                cust_header_selected: null,
                baxter_headers: [],
                chosen_headers: [],
                headers_changed: false,
                headers_changed_ignore: false,
                headers_name: '',
                prevent_submit_reason: [],
                headers_watcher_unwatch: false,
            };
        },
        created() {
            this.uploadFileProcess();
        },
        methods: {
            reprocessHeaders() {
                const rowids = [];
                Object.keys(this.rows).forEach((value) => {
                    rowids.push(value);
                });
                const data = {
                    reprocess_headers: 1,
                    chosen_headers: this.chosen_headers,
                    headers_name: this.headers_name,
                    cust_header_selected: this.cust_header_selected,
                    rows: rowids,
                };
                CsvService.setHeaders(data).then(async () => {
                    this.uploadFileProcess();
                    this.headers_changed = false;
                    if (this.headers_watcher_unwatch) {
                        this.headers_watcher_unwatch();
                    }
                    this.$emit('cancel_upload');
                    this.$emit('waiting_set', false);
                });
            },
            uploadFileProcess() {
                this.$emit('waiting_set', 'Processing headers');
                this.$emit('progress', 30);
                CsvService.processCsv(this.uploadCode)
                    .then(async (res) => {
                        this.rows = res.data.rows;
                        this.filename = res.data.filename;
                        this.rows_num = res.data.rows_num;
                        this.rows_valid = res.data.rows_valid;
                        this.rows_invalid = res.data.rows_invalid;
                        this.selected_rows = [];
                        this.prevent_submit_reason = [];
                        this.headers_file = Object.keys(this.rows[Object.keys(this.rows)[0]]);
                        // load up valid rows with default true
                        Object.keys(this.rows).forEach((value, index) => {
                            if ((this.rows[Object.keys(this.rows)[index]].valid) === 'VALID') {
                                this.selected_rows.push(value);
                            }
                        });

                        this.$emit('waiting_set', 'Assigning headers');
                        this.$emit('progress', 65);
                        this.fetchHeaders();
                     });
            },
            fetchHeaders() {
                CsvService.getHeaders(this.uploadCode).then(async (resHeaders) => {
                    this.cust_headers = resHeaders.data.user_headers;
                    this.baxter_headers = resHeaders.data.baxter_headers;

                    this.cust_header_chosen = resHeaders.data.cust_header_chosen ?? false;
                    this.cust_header_selected = this.cust_header_chosen;
                    // Object.keys(this.cust_headers).forEach((value) => {
                    //     if (this.filename.toLowerCase().includes(value.toLowerCase())) {
                    //         this.cust_header_chosen = value;
                    //     }
                    // });
                    this.$emit('progress', 100);

                    this.chosen_headers = [];
                    this.headers_file.forEach((fileHeader) => {
                        if (fileHeader !== 'valid') {
                            if (this.cust_header_chosen) {
                                this.chosen_headers.push({ field: fileHeader, value: this.cust_headers[this.cust_header_chosen][fileHeader] });
                            } else {
                                this.chosen_headers.push({ field: fileHeader, value: this.baxter_headers.includes(fileHeader) ? fileHeader : '' });
                            }
                        }
                    });
                    this.headers_watcher_unwatch = this.$watch('chosen_headers', this.headersChangeWatcher, { deep: true });
                    this.headers_changed = false;
                    this.headers_name = '';
                    this.$emit('waiting_set', false);
                    if (!this.cust_header_chosen) {
                        this.headers_changed = true;
                    }
                });
            },
            headersChangeWatcher() {
                this.headers_changed = true;
            },
            selectRow(row, rowIsValid) {
                if (rowIsValid) {
                    if (this.selected_rows.includes(row)) {
                        this.selected_rows.splice(this.selected_rows.findIndex((v) => (v === row)), 1);
                    } else {
                        this.selected_rows.push(row);
                    }
                }
            },
            selectedRowsProcess() {
                this.$emit('progress', 0);
                this.$emit('waiting_set', 'Setting selected rows');
                const data = {
                    selected_rows: this.selected_rows,
                };
                if (this.headers_name.length > 0) {
                    data.headers_name = this.headers_name;
                    data.chosen_headers = this.chosen_headers;
                }
                if (this.cust_header_chosen) {
                    data.cust_header_chosen = this.cust_header_chosen;
                }
                CsvService.setSelectedCsvRows(data)
                    .then(async () => {
                        // uploadId = res.data;
                        if (Object.keys(this.rows).length > this.selected_rows.length) {
                            // more rows than selected rows, need to set some invalid
                             const discardedRows = [];
                             Object.keys(this.rows).forEach((value) => {
                                if (!this.selected_rows.includes(value)) {
                                    discardedRows.push(value);
                                }
                             });

                            const data2 = {
                                discarded_rows: discardedRows,
                            };
                            CsvService.setDiscardedCsvRows(data2)
                                .then(async () => {
                                    this.$emit('rows_selected');
                                });
                        } else {
                            // No discarded rows
                            this.$emit('rows_selected');
                        }
                    });
            },
            disableSubmit() {
                // prevent submit if

                let preventSubmit = true;

                preventSubmit = preventSubmit && (this.selected_rows.length === 0); // no rows have been selected

                // OR
                //   the headers have changed
                //   AND
                //     no header name has been supplied
                //     AND
                //     the user has not specified to ignore this change
                preventSubmit = preventSubmit || (this.headers_changed && ((this.headers_name.length === 0) && (!this.headers_changed_ignore)));

                // OR
                // any columns have not been assigned fields or skipped

                this.chosen_headers.forEach((chosenHeader) => {
                    if (!chosenHeader.value || chosenHeader.value.length === 0) {
                        preventSubmit = true;
                        this.push_unique(this.prevent_submit_reason, 'Please ensure all columns in your upload have been assigned to fields.');
                    }
                });

                preventSubmit = preventSubmit || this.headers_changed;

                if (!preventSubmit) {
                    this.prevent_submit_reason = [];
                }
                return preventSubmit;
            },
        },
    };
</script>
